# Usage:
#   Place the <amount-loading-spinner> tag once on the page.
#   Instantiate by broadcasting "amountLoadingSpinner:open" with a spinnerConfig hash containing:
#     * iconName: String; the name of the icon image from the `icon-map.svg` (optional; default: #icon-loading)
#     * loadingMessage: String or ApplicationCtrl-scoped variable

angular.module("avant.customer_applications.directives").directive "amountLoadingSpinner", ['$rootScope', ($rootScope) ->
  restrict: 'E'
  scope: false
  template: '''
    <div class="loading__overlay" ng-class="{ 'loading__overlay--show': isSpinning }">
      <h2 class="loading__headline headline headline--light">
        {{ currLoadingMessage }}
      </h2>
      <amount-icon
        css-classes="loading__oval"
        icon-name="{{ iconName }}">
      </amount-icon>
    </div>
  '''
  link: (scope, element, attrs) ->
    scope.useAmountLoadingSpinner = true # This is used to determine whether to use the new directive or old loading spinner
    scope.isSpinning = false

    scope.closeSpinner = () ->
      # Re-enable form submission and main page scrolling
      $rootScope.$broadcast "submitDisabled", false
      $rootScope.scrollLock = false

      scope.spinnerConfig = null
      scope.isSpinning = false
      scope.currLoadingMessage = null
      scope.iconName = null
      true

    scope.openSpinner = (spinnerConfig) ->
      # Prevent form submission and main page scrolling
      $rootScope.$broadcast "submitDisabled", true
      $rootScope.scrollLock = true

      scope.spinnerConfig = spinnerConfig || {}
      scope.currLoadingMessage = scope.spinnerConfig.loadingMessage || # check for a passed in value first
        scope.loadingMessage || # then check for vars set to the ApplicationCtrl scope
        scope.modal_message # then check the var used in old loading spinner modal (for page submission sequenced messages)
      scope.iconName = scope.spinnerConfig.iconName || "#icon-loading"
      scope.isSpinning = true

    scope.$on("amountLoadingSpinner:open", (ev, spinnerConfig) ->
      scope.openSpinner(spinnerConfig)
    )

    scope.$on("amountLoadingSpinner:close", (ev) ->
      scope.closeSpinner()
    )
]
